import { HttpClient } from '@angular/common/http'
import { Component, OnInit } from '@angular/core'
import { MemberService } from '../member.service'
import { environment } from '../../../../environments/environment'
import { ToastrService } from 'ngx-toastr'
import { CommonModule } from '@angular/common'
import { Router } from '@angular/router'
import { MemberModel } from '../member.model'
import { ClientService } from '../../client/client.service'
import { ClientModel } from '../../client/client.model'
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component'
import { MatDialog } from '@angular/material/dialog'
import { FormsModule } from '@angular/forms'
import { AuthStateService } from '../../../auth-state.service'

@Component({
  selector: 'app-view-members',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './view-members.component.html',
  styleUrl: './view-members.component.css',
})
export class ViewMembersComponent implements OnInit {
  isLoading: boolean = false
  membersData: MemberModel[] = []
  clientsData: ClientModel[] = []
  filteredMembersData: MemberModel[] = [];
  selectedClientId: number | string = "";
  permissions: string[]= [];


  constructor(
    private authStateService: AuthStateService,
    private memberService: MemberService,
    private clientService: ClientService,
    private toastr: ToastrService,
    private router: Router,
    private dialog: MatDialog,
  ) {
    this.authStateService.permissions.subscribe((permList) =>{
      this.permissions = permList
    })

  }

  ngOnInit(): void {
    this.memberService.getAllMembers().subscribe({
      next: (data: any) => {
        this.membersData = data
        this.filterMembers()
      },
      error: (error: any) => {
        this.isLoading = false
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })

    this.clientService.getAllClients().subscribe({
      next: (data: any) => {
        this.clientsData = data
        if(this.clientsData.length > 0){
          this.filterMembers()
        }
        
      },
      error: (error: any) => {
        this.isLoading = false
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  hasPermission(action: string): boolean {
    return this.permissions.includes(action)
  }

  viewMember(member: MemberModel) {
    this.router.navigate(['/addMember'], {
      queryParams: { mode: 'view', ...member },
    })
  }

  updateMember(member: MemberModel) {
    

    this.router.navigate(['/addMember'], {
      queryParams: { mode: 'update', ...member },
    })
  }

  deleteMember(member: MemberModel): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: 'Are you sure you want to delete this member?' },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.memberService.deleteMember(member).subscribe({
          next: () => {
            this.membersData = this.membersData.filter(
              (p) => p.id !== member.id,
            )
            this.toastr.success('Member Deleted Successfully!', 'Success')
          },
          error: (error: any) => {
            this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
          },
        })
      }
    })
  }

  getClientName(clientId: number): string {
    const client = this.clientsData.find(c => c.id === clientId);
    return client ? client.companyName : 'Unknown';
  }

  filterMembers() {
    if (this.selectedClientId) {
      this.filteredMembersData = this.membersData.filter(member => member.clientId.toString() === this.selectedClientId?.toString());
    } else {
      this.filteredMembersData = this.membersData;
    }
  }

}
